<template>
  <div>
    <a-table :scroll="{ x: 1800 }" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" :loading="loading" row-key="id" @change="handleTableChange">
      <template slot="action" slot-scope="text, record">
        <a-dropdown placement="bottomCenter">
          <a-icon type="more" />
          <a-menu slot="overlay">
            <a-menu-item>
              <a class="ant-dropdown-link" @click="onEdit(record)">编辑故障</a>
            </a-menu-item>
            <a-menu-item>
              <a class="ant-dropdown-link" @click="onDelete(record.id)">删除故障</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
      <template slot="level" slot-scope="text, record">
        <a-tag v-if="faultLevels[record.level]" :color="faultLevels[record.level].color">{{ faultLevels[record.level].label }}</a-tag>
        <span v-else>--</span>
      </template>
      <template slot="faultTitle" slot-scope="text, record">
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ record.title }}</span>
          </template>
          <a class="custom-link" @click="onDetail(record)">{{ record.title }}</a>
        </a-tooltip>
      </template>
      <template slot="recapStatus" slot-scope="text, record">
        <a-tag v-if="faultRecapStatus[record.recap_status]" :color="faultRecapStatus[record.recap_status].color">{{ faultRecapStatus[record.recap_status].label }}</a-tag>
        <span v-else>--</span>
      </template>
      <template slot="tag" slot-scope="text, record">
        <a-popover placement="topLeft">
          <template slot="content">
            <a-tag v-for="(tag, index) in record.tags" :key="index" :color="tag.color">{{ tag.name }}</a-tag>
          </template>
          <template slot="title">
            <span>故障标签</span>
          </template>
          <a-tag v-for="(tag, index) in record.tags" :key="index" :color="tag.color">{{ tag.name }}</a-tag>
        </a-popover>
      </template>
      <template slot="domain" slot-scope="text, record">
        <a-popover placement="topLeft">
          <template slot="content">
            <a-tag v-for="(item, index) in record.domains" :key="index" color="pink">{{ item.name }}</a-tag>
          </template>
          <template slot="title">
            <span>关联业务域</span>
          </template>
          <a-tag v-for="(item, index) in record.domains" :key="index" color="pink">{{ item.name }}</a-tag>
        </a-popover>
      </template>
      <template slot="creator" slot-scope="text, record">{{ record.creator.nickname }}</template>
    </a-table>
  </div>
</template>

<script>
import { faultLevels, faultRecapStatus } from '@/utils/dictionary';

const columns = [
  {
    width: 20,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 90,
    customRender: text => {
      return `RCA-${text}`;
    }
  },
  {
    title: '标题',
    width: 300,
    ellipsis: true,
    scopedSlots: { customRender: 'faultTitle' }
  },
  {
    title: '故障等级',
    width: 80,
    scopedSlots: { customRender: 'level' }
  },
  {
    title: '复盘状态',
    width: 80,
    scopedSlots: { customRender: 'recapStatus' }
  },
  {
    title: '提报人',
    width: 100,
    ellipsis: true,
    key: 'creator',
    dataIndex: 'creator',
    customRender: (_value, _row, index) => {
      return _value && _value.user_id !== 0 ? _value.nickname : '--';
    }
  },
  {
    title: '关联业务域',
    width: 150,
    scopedSlots: { customRender: 'domain' },
    ellipsis: true
  },
  {
    title: '标签',
    width: 150,
    ellipsis: true,
    scopedSlots: { customRender: 'tag' }
  },
  {
    width: 100,
    ellipsis: true,
    title: '复盘组织人',
    key: 'recap_organizer',
    dataIndex: 'recap_organizer',
    customRender: (_value, _row, index) => {
      return _value && _value.user_id !== 0 ? _value.nickname : '--';
    }
  },
  {
    width: 150,
    ellipsis: true,
    title: '复盘参与人',
    key: 'recap_players',
    dataIndex: 'recap_players',
    customRender: (_value, _row, index) => {
      return Array.isArray(_value) && _value.length > 0 ? _value.map(item => item.nickname).join('; ') : '--';
    }
  },
  {
    title: '上报时间',
    key: 'reported_time',
    dataIndex: 'reported_time',
    width: 164
  },
  {
    title: '影响时长',
    key: 'impact_duration',
    dataIndex: 'impact_duration',
    width: 100,
    ellipsis: true
  },
  {
    title: '处理时长',
    key: 'handle_duration',
    dataIndex: 'handle_duration',
    width: 100,
    ellipsis: true
  },
  {
    title: '创建时间',
    width: 164,
    dataIndex: 'created_time',
    key: 'created_time',
    customRender: text => {
      return text || '--';
    }
  }
];

export default {
  name: 'FaultDataList',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      columns,
      faultLevels,
      faultRecapStatus
    };
  },
  methods: {
    handleTableChange(pagination) {
      this.$emit('page-change', pagination);
    },
    onEdit(record) {
      this.$emit('edit', record);
    },
    onDelete(id) {
      this.$emit('delete', id);
    },
    onDetail(record) {
      this.$emit('detail', record);
    }
  }
};
</script>

<style lang="less" scoped>
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
</style>
